import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TbCheck, TbCircleX } from "react-icons/tb";
import { CustomButton, CustomLoader } from "../../../components";
import AxiosInstance from "../../../services/Api";
import styles from "./Pricing.module.css";

const CompareFeatures = () => {
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchModules = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await AxiosInstance.post("/saas/module/list", {
          is_core: "",
          is_ai: "",
          is_addon: 0,
          page: "",
          limit: "",
        });
        setModules(response.data?.data || []);
      } catch (err) {
        setError("Unable to load features right now. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchModules();
  }, []);

  return (
    <div className={`page-container ${styles.pricingPage}`}>
      <div className={styles.compareHeaderRow}>
        <CustomButton
          variant="outline-primary"
          fullWidth={false}
          rounded
          className={styles.backBtn}
          onClick={() => navigate(-1)}
        >
          Back
        </CustomButton>
        <h1 className={`heading ${styles.compareTitle}`}>
          Compare <span className="gradientText">Features</span>
        </h1>
        <span className={styles.compareHeaderSpacer} />
      </div>

      {loading && (
        <div className={styles.compareStateWrap}>
          <CustomLoader text="Loading features..." />
        </div>
      )}

      {!loading && error && (
        <div className={styles.compareStateWrap}>
          <p className={styles.compareErrorText}>{error}</p>
        </div>
      )}

      {!loading && !error && (
        <div className={styles.compareTableWrap}>
          <table className={styles.compareTable}>
            <thead>
              <tr>
                <th
                  className={`${styles.compareTableHeadCell} ${styles.compareFeatureCell}`}
                >
                  Feature Category
                </th>
                <th className={styles.compareTableHeadCell}>Core Features</th>
                <th className={styles.compareTableHeadCell}>
                  Core Features + AI
                </th>
              </tr>
            </thead>
            <tbody>
              {modules.map((module) => {
                const hasCore = module.is_core === 1;
                const hasAi = module.is_ai === 1;
                return (
                  <tr key={module.id}>
                    <td
                      className={`${styles.compareBodyCell} ${styles.compareFeatureCell}`}
                    >
                      <span className={styles.compareFeatureName}>
                        {module.name}
                      </span>
                      <span className={styles.compareFeatureDesc}>
                        {module.description}
                      </span>
                    </td>
                    <td
                      className={`${styles.compareBodyCell} ${styles.compareCheckCell}`}
                    >
                      {hasCore ? (
                        <TbCheck className={styles.compareCheckIcon} />
                      ) : (
                        <TbCircleX className={styles.compareCrossIcon} />
                      )}
                    </td>
                    <td
                      className={`${styles.compareBodyCell} ${styles.compareCheckCell}`}
                    >
                      {hasCore || hasAi ? (
                        <TbCheck className={styles.compareCheckIcon} />
                      ) : (
                        <TbCircleX className={styles.compareCrossIcon} />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CompareFeatures;
